//@flow
import * as React from 'react';
import classnames from 'classnames';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

import Link from 'react-toolbox/lib/link';
import theme from './CopyLink.scss';
import { themr } from 'react-css-themr';
import MlFontIcon from 'common/components/core/font_icon/MlFontIcon';
import _ from 'lodash';

type Props = {
    theme: Object,
    copySuccessTimeout: ?number,
    copyContent: string,
    isCopied?: boolean,
    className?: string,
    onClick?: () => void,
    onCopy?: string => void
};

type State = {
    copySuccess: boolean
};

const copyLinkFactory = ({
    CopyComponent = CopyComponent,
    options = { theme }
}) => {
    const { theme: defaultTheme } = { ...options };
    class CopyLink extends React.PureComponent<Props, State> {
        state: State;
        static defaultProps = {
            copySuccessTimeout: null
        };
        constructor(props: Props) {
            super(props);
            this.state = {
                copySuccess: false
            };
        }
        copyClick = (...args) => {
            const { onClick } = this.props;
            onClick && onClick(...args);
            this.textareaContainer && this.textareaContainer.select();
            try {
                var successful = document.execCommand('copy');
                if (successful) {
                    this.setState({ copySuccess: true });
                    this.onCopySuccess();
                } else {
                    this.setState({ copySuccess: false });
                    // no browser support, copy fails
                }
            } catch (err) {
                this.setState({ copySuccess: false });
                // no browser support, copy fails
            }
        };
        onCopySuccess() {
            if (this.timeout) clearTimeout(this.timeout);
            if (this.props.copySuccessTimeout !== null)
                this.timeout = setTimeout(
                    () => this.setState({ copySuccess: false }),
                    this.props.copySuccessTimeout
                );
            this.props.onCopy && this.props.onCopy(this.props.copyContent);
        }
        getTextareaRef = ref => {
            this.textareaContainer = ref;
        };
        render() {
            const {
                copyContent,
                theme,
                className,
                isCopied,
                ...others
            } = this.props;
            const isLinkCopied = _.isUndefined(isCopied)
                ? this.state.copySuccess
                : this.state.copySuccess && isCopied;
            // take copy state from props
            return (
                <div className={classnames(theme.copyLink, className)}>
                    <CopyComponent
                        {...others}
                        theme={theme}
                        isCopied={isLinkCopied}
                        onClick={this.copyClick}
                    />
                    <textarea
                        ref={this.getTextareaRef}
                        defaultValue={copyContent}
                        readOnly
                        className={theme.copyArea}
                    />
                </div>
            );
        }
    }
    return compose(themr('CopyLink', defaultTheme), translate())(CopyLink);
};

const CopyComponent = ({ onClick, theme, isCopied, t, ...others }) => {
    return isCopied ? (
        <div className={theme.copySuccess}>
            <MlFontIcon
                className={theme.tickIcon}
                iconClass="tickmark"
                color="cool-green"
                theme={theme}
            />
            <span>{t('copied')}</span>
        </div>
    ) : (
        <Link {...others} onClick={onClick} theme={theme} />
    );
};
const ThemedCopyLink = copyLinkFactory({ CopyComponent, theme });
export { ThemedCopyLink as CopyLink, copyLinkFactory };
export default copyLinkFactory;
